var link_viewer_wrapper_default = {
  "anchor": "_1bID5",
  "link": "_1z7ui"
};
export {
  link_viewer_wrapper_default as default
};
//# sourceMappingURL=link-viewer-wrapper-scss.js.map
